import type { AnchorHTMLAttributes, HTMLAttributeAnchorTarget, ReactNode } from "react";

type LinkProps = Omit<AnchorHTMLAttributes<HTMLAnchorElement>, "href"> & {
  href: string;
  children?: ReactNode;
  className?: string;
  text: string;
  target?: HTMLAttributeAnchorTarget;
};

export const Link = ({ href, children, className, text, target }: LinkProps) => {
  return (
    <a href={href} className={className} target={target}>
      {text}
      {children}
    </a>
  );
};
